import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { E as d, S as v } from "./icons.types-0722eef5.js";
function p({ title: o, titleId: s, size: i, width: h, height: c, extended: r = !1, ...t }) {
  const n = r ? d : v, f = i ? n[i] : h || n[r ? "s" : "l"], a = i ? n[i] : c || n[r ? "s" : "l"];
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: f,
      height: a,
      "aria-labelledby": s,
      ...t,
      children: [
        o ? /* @__PURE__ */ l("title", { id: s, children: o }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#On_-_off_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M37.8 28.8h-3.6V3.6h3.6v25.2Zm3.605-17.404v3.717C50.704 17.52 57.6 25.96 57.6 36c0 11.91-9.69 21.6-21.6 21.6-11.91 0-21.6-9.69-21.6-21.6 0-10.044 6.901-18.486 16.205-20.89v-3.716C19.283 13.866 10.8 23.936 10.8 36c0 13.918 11.282 25.2 25.2 25.2 13.917 0 25.2-11.282 25.2-25.2 0-12.06-8.478-22.127-19.795-24.604Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "On_-_off_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as OnOff
};
